import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import User from '_class/User';
import { setPageTitle, setPageActions } from 'actions/header';
import { getSchoolAdjustments, getAdditionalAdjustments, updateAdditionalAdjustment, getStudentAdjustments, updateStudentAdjustment, deleteAdditionalAdjustment, deleteStudentAdjustment } from 'actions/additional_adjustments';
import { clearSearchResults } from 'actions/search';
import { getStudentAdditionalAdjustmentsForGroup } from 'actions/sections';
import { GetGroupedByStudent, AddUnusedAdditionalAdjustments } from '../Helpers';
import AssignAdditionalAdjustments from './AssignAdditionalAdjustments';
import StudentAdjustment from 'containers/AdditionalAdjustments/Display/StudentAdjustment';
import EditStudentAdjustmentForm from '../Form/EditStudentAdjustmentForm';
import CreateAdditionalAdjustment from './CreateAdditionalAdjustment';
import Redirect from 'components/Redirect/Redirect';
import { Block, Icon, TooltipMenu, Flex, Button, Tabs, Tab, translate } from '@haldor/ui';
import Modal from 'containers/Modals/Modal';
import { Spinner, Collapsible, Person } from 'UI';
import '../Display/GroupAdjustments.scss';
import './AdministrateAdjustments.scss';

var AdministrateAdjustments = /*#__PURE__*/function (_Component) {
  _inherits(AdministrateAdjustments, _Component);

  var _super = _createSuper(AdministrateAdjustments);

  function AdministrateAdjustments(props) {
    var _this;

    _classCallCheck(this, AdministrateAdjustments);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onStudentAdjustmentEdit", function (studentAdjustment) {
      _this.setState({
        editAdjustment: true,
        adjustment: studentAdjustment
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onStudentClick", function (student) {
      _this.setState({
        activeStudent: student,
        studentAdjustmentsModal: true,
        loadingStudentAdjustments: true
      });

      var fetchStudent = false;

      if (_this.props.studentAdjustments != null && _this.props.studentAdjustments.length > 0) {
        if (_this.props.studentAdjustments[0].studentID != student.userId) {
          fetchStudent = true;
        } else {
          var adjustmentId = student.items[0].adjustmentID;

          _this.setState({
            loadingStudentAdjustments: false,
            studentAdjustmentId: adjustmentId
          });
        }
      } else {
        fetchStudent = true;
      }

      if (fetchStudent) {
        _this.props.getStudentAdjustments(student.userId).then(function () {
          var adjustmentId = student.items[0].adjustmentID;

          _this.setState({
            loadingStudentAdjustments: false,
            studentAdjustmentId: adjustmentId
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "closeStudent", function () {
      _this.setState({
        activeStudent: null,
        studentAdjustmentsModal: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleStudentAdjustment", function (adjustment) {
      if (adjustment != null) {
        _this.setState({
          activeStudentAdjustment: adjustment.id
        });
      } else {
        _this.setState({
          activeStudentAdjustment: null
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updateAdjustmentStatus", function (adjustment, status) {
      var values = _objectSpread({}, adjustment);

      values.status = status;

      _this.props.updateAdditionalAdjustment(values).then(function () {
        var promises = [_this.props.getSchoolAdjustments(), _this.props.getAdditionalAdjustments()];
        Promise.all(promises);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateStudentAdjustmentStatus", function (studentAdjustment, status) {
      var values = _objectSpread({}, studentAdjustment);

      values.status = status; // Clean up properties that doesnt need to be sent to the api

      delete values.comments;
      delete values.courses;
      delete values.createdBy;
      delete values.editedBy;
      delete values.versions;
      delete values.student;

      _this.props.updateStudentAdjustment(values);
    });

    _defineProperty(_assertThisInitialized(_this), "deleteStudentAdjustment", function (studentAdjustment) {
      _this.props.deleteStudentAdjustment(studentAdjustment);
    });

    _defineProperty(_assertThisInitialized(_this), "toggleCreateAdditionalAdjustment", function () {
      _this.setState({
        createAdjustmentModal: !_this.state.createAdjustmentModal,
        adjustment: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleAssignStudentAdditionalAdjustment", function () {
      if (_this.state.assignAdjustmentModal == false) {
        _this.setState({
          assignAdjustmentModal: !_this.state.assignAdjustmentModal
        });
      } else {
        _this.setState({
          loading: true,
          assignAdjustmentModal: !_this.state.assignAdjustmentModal
        });

        var promises = [_this.props.getSchoolAdjustments(), _this.props.getAdditionalAdjustments(), _this.props.clearSearchResults()];
        Promise.all(promises).then(function () {
          _this.setState({
            loading: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onStudentAdjustmentSubmit", function (values) {
      return new Promise(function (resolve) {
        // Clean up properties that doesnt need to be sent to the api
        delete values.comments;
        delete values.courses;
        delete values.createdBy;
        delete values.editedBy;
        delete values.versions;
        delete values.student;

        _this.props.updateStudentAdjustment(values).then(function () {
          resolve(1);

          _this.setState({
            editAdjustment: false,
            adjustment: null
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAdjustmentDelete", function (adjustment) {
      _this.props.deleteAdditionalAdjustment(adjustment);
    });

    _defineProperty(_assertThisInitialized(_this), "onStatusSelect", function (event) {
      if (event.target.value == '0') {
        _this.setState({
          selectedStatus: null
        });

        return true;
      }

      _this.setState({
        selectedStatus: event.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGroupSelect", function (event) {
      _this.setState({
        selectedGroup: event.target.value
      });

      if (event.target.value != '0') {
        _this.setState({
          loading: true
        });

        _this.props.getStudentAdditionalAdjustmentsForGroup(event.target.value).then(function () {
          _this.setState({
            loading: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clearFilter", function () {
      _this.setState({
        selectedGroup: "0",
        selectedStatus: null,
        loading: true
      });

      var promises = [_this.props.getSchoolAdjustments(), _this.props.getAdditionalAdjustments()];
      Promise.all(promises).then(function () {
        _this.setState({
          loading: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "editAdjustment", function (adjustment) {
      _this.setState({
        adjustment: adjustment,
        createAdjustmentModal: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleEditModal", function () {
      _this.setState({
        editAdjustment: false,
        adjustment: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderFilters", function () {
      var translate = _this.props.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "form filter-container",
        style: {
          marginBottom: '2rem'
        }
      }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
        className: "select"
      }, translate('section'), /*#__PURE__*/React.createElement("select", {
        value: _this.state.selectedGroup,
        onChange: _this.onGroupSelect
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, translate('all-groups')), _this.props.groups != null ? _this.props.groups.map(function (group) {
        return /*#__PURE__*/React.createElement("option", {
          value: group.id,
          key: group.id
        }, group.title);
      }) : null)), /*#__PURE__*/React.createElement("div", {
        className: "select"
      }, translate('Status on the assigned student adjustment'), /*#__PURE__*/React.createElement("select", {
        value: _this.state.selectedStatus,
        onChange: _this.onStatusSelect
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, _this.props.translate('All')), /*#__PURE__*/React.createElement("option", {
        value: "ACTIVE"
      }, _this.props.translate('active')), /*#__PURE__*/React.createElement("option", {
        value: "COMPLETED"
      }, _this.props.translate('adjustment-closed')), /*#__PURE__*/React.createElement("option", {
        value: "DELETED"
      }, _this.props.translate('Deleted'))))), _this.state.selectedStatus != null || _this.state.selectedGroup != '0' ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick() {
          _this.clearFilter();
        }
      }, _this.props.translate("clear"))) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderAdjustmentTrigger", function (adjustment) {
      var dropdownTrigger = /*#__PURE__*/React.createElement("div", {
        className: "dropdown--trigger"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Bullets"
      }));
      var user = new User(_this.props.user);

      var count = _toConsumableArray(adjustment.items).filter(function (student) {
        var hasActive = student.items.find(function (adj) {
          return adj.status == 'ACTIVE';
        });
        return hasActive != null;
      }).length;

      return /*#__PURE__*/React.createElement("div", {
        className: "adj--content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "adj--title"
      }, /*#__PURE__*/React.createElement("b", null, adjustment.title, " ", adjustment.subTitle != null ? " - " + adjustment.subTitle : null)), /*#__PURE__*/React.createElement("div", {
        className: "adj--badge"
      }, count), /*#__PURE__*/React.createElement(TooltipMenu, {
        trigger: dropdownTrigger
      }, adjustment.type == "CUSTOM" ? /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick() {
          _this.editAdjustment(adjustment);
        }
      }, _this.props.translate('Edit')) : null, adjustment.status == 'ACTIVE' ? /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick() {
          _this.updateAdjustmentStatus(adjustment, 'ARCHIVED');
        }
      }, _this.props.translate('Archive')) : null, adjustment.status == 'ARCHIVED' ? /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick() {
          _this.updateAdjustmentStatus(adjustment, 'ACTIVE');
        }
      }, _this.props.translate('Activate')) : null, adjustment.status == 'DELETED' ? /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick() {
          _this.updateAdjustmentStatus(adjustment, 'ARCHIVED');
        }
      }, _this.props.translate('Reset')) : null, adjustment.status == 'ARCHIVED' ? /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick() {
          _this.updateAdjustmentStatus(adjustment, 'DELETED');
        }
      }, _this.props.translate('Delete')) : null, adjustment.status == 'DELETED' && adjustment.deletable && user.isPedagogue() ? /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick() {
          _this.onAdjustmentDelete(adjustment);
        }
      }, _this.props.translate('Delete permanently')) : null));
    });

    _defineProperty(_assertThisInitialized(_this), "renderStudents", function (status) {
      var students = [];
      var adjustments = _this.props.schoolAdjustments;

      if (_this.state.selectedGroup != '0') {
        adjustments = _this.props.groupAdjustments;
      }

      if (adjustments == null) {
        return null;
      }

      if (status != null) {
        adjustments = adjustments.filter(function (adjustment) {
          return adjustment.status == status;
        });
      }

      if (_this.state.selectedStatus != null) {
        adjustments = adjustments.filter(function (adjustment) {
          return adjustment.status == _this.state.selectedStatus;
        });
      }

      adjustments = adjustments.sort(function (a, b) {
        return a.student.firstName == null || b.student.firstName == null ? 0 : a.student.firstName.localeCompare(b.student.firstName);
      });
      adjustments.forEach(function (adjustment) {
        if (students.indexOf(adjustment.studentID) == -1) {
          students.push(adjustment.studentID);
        }
      });
      return /*#__PURE__*/React.createElement(Block, null, _this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : students.map(function (studentId) {
        var foundAdjustments = _toConsumableArray(adjustments).filter(function (adjustment) {
          return adjustment.studentID == studentId;
        });

        var student = null;

        if (foundAdjustments.length > 0) {
          student = foundAdjustments[0].student;
        }

        if (student == null || student.firstName == null || student.userId == null) {
          return null;
        }

        var trigger = /*#__PURE__*/React.createElement("div", {
          className: "adj--content"
        }, /*#__PURE__*/React.createElement("div", {
          className: "adj--title"
        }, /*#__PURE__*/React.createElement(Person, {
          person: student
        })), /*#__PURE__*/React.createElement("div", {
          className: "adj--badge"
        }, foundAdjustments.length));
        var dropdownTrigger = /*#__PURE__*/React.createElement("div", {
          className: "dropdown--trigger"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Bullets"
        }));
        return /*#__PURE__*/React.createElement("div", {
          className: "adjustment",
          key: studentId
        }, /*#__PURE__*/React.createElement(Collapsible, {
          trigger: trigger
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            padding: '0.65rem 0'
          }
        }, foundAdjustments.map(function (adjustment) {
          return /*#__PURE__*/React.createElement("div", {
            style: {
              clear: 'both',
              margin: '0 1.55rem .65rem 5.2rem'
            },
            key: adjustment.id
          }, /*#__PURE__*/React.createElement("div", {
            className: "additionalAdjustmentTrigger",
            onClick: function onClick() {
              return _this.toggleStudentAdjustment(adjustment);
            }
          }, adjustment.additionalAdjustment.title, adjustment.additionalAdjustment.subTitle != null ? ' - ' + adjustment.additionalAdjustment.subTitle : null), /*#__PURE__*/React.createElement("div", {
            style: {
              "float": 'right'
            }
          }, /*#__PURE__*/React.createElement(TooltipMenu, {
            trigger: dropdownTrigger
          }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
            onClick: function onClick() {
              _this.onStudentAdjustmentEdit(adjustment);
            }
          }, _this.props.translate('Edit')), adjustment.status == 'ACTIVE' ? /*#__PURE__*/React.createElement(TooltipMenu.Item, {
            onClick: function onClick() {
              _this.updateStudentAdjustmentStatus(adjustment, 'COMPLETED');
            }
          }, _this.props.translate('Complete')) : null, adjustment.status == 'COMPLETED' ? /*#__PURE__*/React.createElement(TooltipMenu.Item, {
            onClick: function onClick() {
              _this.updateStudentAdjustmentStatus(adjustment, 'ACTIVE');
            }
          }, _this.props.translate('Activate')) : null, adjustment.status == 'COMPLETED' ? /*#__PURE__*/React.createElement(TooltipMenu.Item, {
            onClick: function onClick() {
              _this.updateStudentAdjustmentStatus(adjustment, 'DELETED');
            }
          }, _this.props.translate('Delete')) : null, adjustment.status == 'DELETED' ? /*#__PURE__*/React.createElement(TooltipMenu.Item, {
            onClick: function onClick() {
              _this.updateStudentAdjustmentStatus(adjustment, 'COMPLETED');
            }
          }, _this.props.translate('Reset')) : null, adjustment.status == 'DELETED' ? /*#__PURE__*/React.createElement(TooltipMenu.Item, {
            onClick: function onClick() {
              _this.deleteStudentAdjustment(adjustment);
            }
          }, _this.props.translate('Remove permanently')) : null)), /*#__PURE__*/React.createElement("div", {
            className: "clearfix"
          }));
        }))));
      }));
    });

    _this.state = {
      editAdjustment: false,
      createAdjustmentModal: false,
      assignAdjustmentModal: false,
      loading: true,
      activeStudent: null,
      activeStudentAdjustment: null,
      adjustment: null,
      selectedStatus: null,
      selectedGroup: '0',
      studentAdjustmentsModal: false,
      loadingStudentAdjustments: false,
      studentAdjustmentId: null
    };
    return _this;
  }

  _createClass(AdministrateAdjustments, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.props.setPageTitle(this.props.translate('additional-adjustments'));
      var promises = [this.props.getSchoolAdjustments(), this.props.getAdditionalAdjustments()];
      Promise.all(promises).then(function () {
        _this2.setState({
          loading: false
        });
      });
      var actions = [];
      actions.push({
        type: 'button',
        value: this.props.translate('Create additional adjustment template'),
        onClick: this.toggleCreateAdditionalAdjustment,
        icon: 'plus'
      });
      actions.push({
        type: 'button',
        value: this.props.translate('assign-adjustment'),
        onClick: this.toggleAssignStudentAdditionalAdjustment,
        icon: 'plus'
      });
      this.props.setPageActions(actions);
    }
    /* Events */

  }, {
    key: "renderModals",
    value:
    /* Render methods */
    function renderModals() {
      var _this3 = this,
          _this$state$activeStu,
          _this$state$activeStu2;

      var adjustments = this.props.schoolAdjustments;

      if (this.state.selectedGroup != '0') {
        adjustments = this.props.groupAdjustments;
      }

      var completed = [];
      this.props.studentAdjustments.forEach(function (adjustment) {
        if (adjustment.adjustmentID == _this3.state.studentAdjustmentId && adjustment.status == 'COMPLETED') {
          completed.push(adjustment);
        }
      });
      var studentAdjustmentModalTitle = '';
      var studentAdjustment = null;

      if (this.state.activeStudentAdjustment != null) {
        studentAdjustment = adjustments.find(function (adj) {
          return adj.id == _this3.state.activeStudentAdjustment;
        });

        if (studentAdjustment != null) {
          studentAdjustmentModalTitle += studentAdjustment.student.firstName + ' ' + studentAdjustment.student.lastName;
          studentAdjustmentModalTitle += ' - ' + studentAdjustment.additionalAdjustment.title;

          if (studentAdjustment.additionalAdjustment.subTitle != null) {
            studentAdjustmentModalTitle += ' - ' + studentAdjustment.additionalAdjustment.subTitle;
          }
        }
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
        isOpen: studentAdjustment != null,
        onClose: function onClose() {
          return _this3.toggleStudentAdjustment();
        },
        title: studentAdjustmentModalTitle,
        type: "small"
      }, /*#__PURE__*/React.createElement("div", {
        className: "studentAdjustmentModal"
      }, /*#__PURE__*/React.createElement(StudentAdjustment, {
        adjustment: studentAdjustment
      }))), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.editAdjustment,
        onClose: this.toggleEditModal,
        title: this.props.translate('Edit adjustment')
      }, /*#__PURE__*/React.createElement(EditStudentAdjustmentForm, {
        adjustment: this.state.adjustment,
        onClose: this.toggleEditModal,
        onSubmit: this.onStudentAdjustmentSubmit
      })), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.createAdjustmentModal,
        onClose: this.toggleCreateAdditionalAdjustment,
        title: this.props.translate('Create additional adjustment template')
      }, /*#__PURE__*/React.createElement(CreateAdditionalAdjustment, {
        onClose: this.toggleCreateAdditionalAdjustment,
        editAdjustment: this.state.adjustment
      })), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.assignAdjustmentModal,
        onClose: this.toggleAssignStudentAdditionalAdjustment,
        title: this.props.translate('assign-adjustment')
      }, /*#__PURE__*/React.createElement(AssignAdditionalAdjustments, {
        onClose: this.toggleAssignStudentAdditionalAdjustment
      })), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.studentAdjustmentsModal,
        onClose: this.closeStudent,
        title: (((_this$state$activeStu = this.state.activeStudent) === null || _this$state$activeStu === void 0 ? void 0 : _this$state$activeStu.firstName) || '') + ' ' + (((_this$state$activeStu2 = this.state.activeStudent) === null || _this$state$activeStu2 === void 0 ? void 0 : _this$state$activeStu2.lastName) || '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "studentAdjustmentModal"
      }, this.state.loadingStudentAdjustments ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : this.props.studentAdjustments.map(function (adjustment) {
        if (adjustment.adjustmentID == _this3.state.studentAdjustmentId && (_this3.state.selectedStatus == null || adjustment.status == _this3.state.selectedStatus)) {
          return /*#__PURE__*/React.createElement(StudentAdjustment, {
            key: adjustment.id,
            adjustment: adjustment
          });
        }
      }), this.state.selectedStatus == null && this.state.loadingStudentAdjustments == false && completed.length > 0 ? /*#__PURE__*/React.createElement(Collapsible, {
        trigger: this.props.translate('completed')
      }, completed.map(function (adjustment) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            padding: '4px'
          },
          key: adjustment.id
        }, /*#__PURE__*/React.createElement(StudentAdjustment, {
          adjustment: adjustment
        }));
      })) : null)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      if (!this.props.services.additionalAdjustments) {
        return /*#__PURE__*/React.createElement(Redirect, {
          to: "/"
        });
      }

      var adjustments = this.props.schoolAdjustments;
      var statusFilter = null; // Apply filters

      statusFilter = this.state.selectedStatus;

      if (this.state.selectedGroup != '0') {
        adjustments = this.props.groupAdjustments;
      }

      var translate = this.props.translate;
      var user = new User(this.props.user);
      var result = GetGroupedByStudent(adjustments, statusFilter);
      result = AddUnusedAdditionalAdjustments(result, this.props.adjustments);
      return /*#__PURE__*/React.createElement("div", {
        className: "adjustments spec-pedagog"
      }, this.renderModals(), /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement(Tab, {
        title: translate('students'),
        route: "students"
      }, this.renderFilters(), this.state.selectedStatus == null ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Collapsible, {
        open: true,
        trigger: this.props.translate('active')
      }, /*#__PURE__*/React.createElement("div", {
        className: "group-adjustment"
      }, this.renderStudents('ACTIVE'))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1.55rem'
        }
      }), /*#__PURE__*/React.createElement(Collapsible, {
        trigger: this.props.translate('completed')
      }, /*#__PURE__*/React.createElement("div", {
        className: "group-adjustment"
      }, this.renderStudents('COMPLETED'))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1.55rem'
        }
      }), user.isPedagogue() ? /*#__PURE__*/React.createElement(Collapsible, {
        trigger: this.props.translate('Deleted')
      }, /*#__PURE__*/React.createElement("div", {
        className: "group-adjustment"
      }, this.renderStudents('DELETED'))) : null) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Collapsible, {
        open: true,
        trigger: this.props.translate(this.state.selectedStatus.toLowerCase())
      }, /*#__PURE__*/React.createElement("div", {
        className: "group-adjustment"
      }, this.renderStudents(this.state.selectedStatus))))), /*#__PURE__*/React.createElement(Tab, {
        title: translate('Templates'),
        route: "templates"
      }, this.renderFilters(), /*#__PURE__*/React.createElement(Collapsible, {
        open: true,
        trigger: translate('Active')
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("div", {
        className: "group-adjustment"
      }, this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : result.length > 0 ? result.map(function (adjustment) {
        if (adjustment.status != 'ACTIVE') {
          return null;
        }

        var trigger = _this4.renderAdjustmentTrigger(adjustment);

        return /*#__PURE__*/React.createElement("div", {
          className: "adjustment",
          key: adjustment.id
        }, /*#__PURE__*/React.createElement(Collapsible, {
          trigger: trigger
        }, adjustment.items.map(function (student) {
          var hasActive = student.items.find(function (adj) {
            return adj.status == 'ACTIVE';
          });
          if (hasActive == null) return null;
          return /*#__PURE__*/React.createElement("div", {
            className: "student",
            key: student.userId
          }, /*#__PURE__*/React.createElement("div", {
            onClick: function onClick() {
              return _this4.onStudentClick(student);
            },
            className: "name"
          }, /*#__PURE__*/React.createElement(Person, {
            person: student
          })));
        })));
      }) : /*#__PURE__*/React.createElement("div", null, this.props.translate('no-adjustments-found'))))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1.55rem'
        }
      }), /*#__PURE__*/React.createElement(Collapsible, {
        trigger: this.props.translate('archived')
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("div", {
        className: "group-adjustment"
      }, this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : result.length > 0 ? result.map(function (adjustment) {
        if (adjustment.status != 'ARCHIVED') {
          return null;
        }

        var trigger = _this4.renderAdjustmentTrigger(adjustment);

        return /*#__PURE__*/React.createElement("div", {
          className: "adjustment",
          key: adjustment.id
        }, /*#__PURE__*/React.createElement(Collapsible, {
          trigger: trigger
        }, adjustment.items.map(function (student) {
          var hasActive = student.items.find(function (adj) {
            return adj.status == 'ACTIVE';
          });
          if (hasActive == null) return null;
          return /*#__PURE__*/React.createElement("div", {
            className: "student",
            key: student.userId
          }, /*#__PURE__*/React.createElement("div", {
            onClick: function onClick() {
              return _this4.onStudentClick(student);
            },
            className: "name"
          }, /*#__PURE__*/React.createElement(Person, {
            person: student
          })));
        })));
      }) : /*#__PURE__*/React.createElement("div", null, this.props.translate('no-adjustments-archived'))))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1.55rem'
        }
      }), user.isPedagogue() ? /*#__PURE__*/React.createElement(Collapsible, {
        trigger: this.props.translate('Deleted')
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("div", {
        className: "group-adjustment"
      }, this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : result.length > 0 ? result.map(function (adjustment) {
        if (adjustment.status != 'DELETED') {
          return null;
        }

        var trigger = _this4.renderAdjustmentTrigger(adjustment);

        return /*#__PURE__*/React.createElement("div", {
          className: "adjustment",
          key: adjustment.id
        }, /*#__PURE__*/React.createElement(Collapsible, {
          trigger: trigger
        }, adjustment.items.map(function (student) {
          var hasActive = student.items.find(function (adj) {
            return adj.status == 'ACTIVE';
          });
          if (hasActive == null) return null;
          return /*#__PURE__*/React.createElement("div", {
            className: "student",
            key: student.userId
          }, /*#__PURE__*/React.createElement("div", {
            onClick: function onClick() {
              return _this4.onStudentClick(student);
            },
            className: "name"
          }, /*#__PURE__*/React.createElement(Person, {
            person: student
          })));
        })));
      }) : /*#__PURE__*/React.createElement("div", null, this.props.translate('no-adjustments-archived'))))) : null)));
    }
  }]);

  return AdministrateAdjustments;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    user: state.user.currentUser,
    schoolAdjustments: state.AdditionalAdjustments.schoolAdjustments,
    adjustments: state.AdditionalAdjustments.adjustments,
    groupAdjustments: state.AdditionalAdjustments.groupAdjustments,
    studentAdjustments: state.AdditionalAdjustments.studentAdjustments,
    groups: state.sections.educationGroups,
    services: state.Services.availableServices
  };
}

export default connect(mapStateToProps, {
  setPageTitle: setPageTitle,
  getSchoolAdjustments: getSchoolAdjustments,
  setPageActions: setPageActions,
  getAdditionalAdjustments: getAdditionalAdjustments,
  updateAdditionalAdjustment: updateAdditionalAdjustment,
  getStudentAdditionalAdjustmentsForGroup: getStudentAdditionalAdjustmentsForGroup,
  clearSearchResults: clearSearchResults,
  getStudentAdjustments: getStudentAdjustments,
  updateStudentAdjustment: updateStudentAdjustment,
  deleteStudentAdjustment: deleteStudentAdjustment,
  deleteAdditionalAdjustment: deleteAdditionalAdjustment
})(AdministrateAdjustments);